import { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { logOut } from "actions";

class Logout extends Component {
  componentDidMount() {
    this.props.logOut();
    this.props.history.push("/login");
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
  };
};

export default connect(mapStateToProps, {
  logOut,
})(containsLongRunningProcess(Logout));
